import styled from 'styled-components';

const StyledFixedDetailsPanel = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const StyledFixedDetailsPanelPanelContainer = styled.div`
  position: ${props => props.fixed ? 'fixed' : 'relative'};
  top: ${props => props.fixed ? '90px' : '0px'};
  width: inherit;

  & > div {
    transition: opacity .3s ease;
  }
`;

export {
  StyledFixedDetailsPanel,
  StyledFixedDetailsPanelPanelContainer,
};
